<template>
    <div v-if="vo && vo.passenger && vo.passenger.appointmnetInfos" class="appointmnetInfos">
        <!-- 固定信息 -->
        <el-form :key="111" :model="vo" @submit.native.prevent>
            <div style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">任职信息</div>
            <div style="width: 100%" class="el-table el-table--fit el-table--border">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                        <tbody>
                            <!-- <tr>
                                <td style="background: #f2f5fb" class="el-table__cell" colspan="6">
                                    <div class="slicer">任职信息</div>
                                </td>
                            </tr> -->
                            <tr>
                                <td ref="tdlbl_员工编号" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'employeeNo'" class="field">员工编号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit && !isMypersonalRecords">
                                        <form-item
                                            ref="employeeNo"
                                            :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入员工编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '员工编号', propName: 'employeeNo', propType: 'String', textFormatter: 'textfield', valueMaxLength: 10, valueMinLength: null, model: 'vo.employeeNo', option: [], autocomplete: 'off', showWordLimit: false }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                    </div>
                                    <div v-else>
                                        {{ vo.employeeNo }}
                                    </div>
                                </td>
                                <td ref="tdlbl_入职日期 " class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'entryDate'" class="field">入职日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit && !isMypersonalRecords">
                                        <form-item
                                            ref="entryDate"
                                            :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: 'format：yyyy年MM月dd日\r\n', elementReadonly: 1, elementType: 'date', emptyMessage: '请输入入职日期 ', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '入职日期 ', propName: 'entryDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日\r\n', valueMaxLength: null, valueMinLength: null, model: 'vo.entryDate', option: [], weekday: 0 }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                    </div>
                                    <div v-else>
                                        {{ timeFormat(vo.entryDate) }}
                                    </div>
                                </td>
                                <td ref="tdlbl_转正日期" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'conversionDate'" class="field">转正日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit && !isMypersonalRecords">
                                        <form-item
                                            ref="conversionDate"
                                            :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请输入转正日期', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '转正日期', propName: 'conversionDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, model: 'vo.conversionDate', option: [], weekday: 0 }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                    </div>
                                    <div v-else>
                                        {{ timeFormat(vo.conversionDate) }}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td ref="tdlbl_机构名称" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'orgName'" class="field">机构名称</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit && !isMypersonalRecords">
                                        <form-item ref="orgName" :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入机构名称', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '机构名称', propName: 'orgName', propType: 'String', textFormatter: 'textfield', valueMaxLength: 200, valueMinLength: null, model: 'vo.orgName', option: [] }" :vo="vo" :can-edit="canEdit" />
                                    </div>
                                    <div v-else>
                                        {{ vo.orgName }}
                                    </div>
                                </td>
                                <td ref="tdlbl_工作性质 " class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'workNature'" class="field">工作方式</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit && !isMypersonalRecords">
                                        <form-item
                                            ref="workNature"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '借调：借调\n外派：外派',
                                                elementReadonly: 1,
                                                elementType: 'radio',
                                                emptyMessage: '请选择工作性质 ',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '工作性质 ',
                                                propName: 'workNature',
                                                propType: 'String',
                                                textFormatter: null,
                                                valueMaxLength: 50,
                                                valueMinLength: null,
                                                model: 'vo.workNature',
                                                option: [
                                                    { value: '借调', name: '借调' },
                                                    { value: '外派', name: '外派' }
                                                ],
                                                optionGenerateType: 0,
                                                clearable: true,
                                                filterable: false,
                                                allowCreate: false
                                            }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                    </div>
                                    <div v-else>
                                        {{ vo.workNature }}
                                    </div>
                                </td>
                                <td ref="tdlbl_借调/外派日期" class="el-table__cell tdlbl tdw13" colspan="1">
                                    <span v-field-lbl="'secondmentDate'" class="field">借调/外派日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw20" colspan="1">
                                    <div v-if="canEdit && !isMypersonalRecords">
                                        <form-item
                                            ref="secondmentDate"
                                            :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 1, elementType: 'date', emptyMessage: '请输入借调/外派日期', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '借调/外派日期', propName: 'secondmentDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, model: 'vo.secondmentDate', option: [], weekday: 0 }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                        />
                                    </div>
                                    <div v-else>
                                        {{ timeFormat(vo.secondmentDate) }}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>
        <!-- 动态新增 -->
        <div v-for="(item, index) in vo.passenger.appointmnetInfos" :key="item.id" class="appointmnetInfosList">
            <div class="rz_title">
                <span>任职信息{{ convertToChineseNumber(index + 1) }}</span>
                <span>
                    <el-link v-if="editEmploy && !isMypersonalRecords" type="danger" size="small" icon="el-icon-delete" @click="delAppointmnetInfo(item)">删除</el-link>
                </span>
            </div>
            <el-form :model="item" @submit.native.prevent>
                <div style="width: 100%" class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td ref="tdlbl_部门" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'department'" class="field">部门</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <div v-if="editEmploy && !isMypersonalRecords">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="部门" :rules="departmentRules">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                    <!-- :root-org-code="vo.orgCode" -->
                                                    <!-- <el-input v-model="item.department" v-select-dialog="'suborg'" org-level="2" dialog-title="选择部门" multiple="false" :index="index" placeholder="请选择部门" name="department" /> -->

                                                    <el-input v-model="item.department" placeholder="请选择部门" class="input-with-select">
                                                        <el-button slot="append" icon="el-icon-more" @click="selectSuborg(item, index, '选择部门', 'department')"></el-button>
                                                    </el-input>
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else>{{ item.department }}</div>
                                    </td>
                                    <td ref="tdlbl_任职类别" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'postType'" class="field">任职类别</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <form-item
                                            ref="postType"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '0：主负责人\n1：主负责人\n2：副负责人\n3：普通员工',
                                                elementReadonly: 1,
                                                elementType: 'select',
                                                emptyMessage: '请选择任职类别',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 1,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '任职类别',
                                                propName: 'postType',
                                                propType: 'Short',
                                                textFormatter: null,
                                                valueMaxLength: 50,
                                                valueMinLength: null,
                                                model: 'item.postType',
                                                option: [
                                                    { value: '1', name: '主负责人' },
                                                    { value: '2', name: '副负责人' },
                                                    { value: '3', name: '普通员工' }
                                                ],
                                                optionGenerateType: 1,
                                                clearable: true,
                                                filterable: false,
                                                allowCreate: false
                                            }"
                                            :vo="item"
                                            :can-edit="editEmploy && !isMypersonalRecords"
                                        />
                                    </td>
                                    <td ref="tdlbl_职务  " class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'post'" class="field">职务</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <!-- 选择数据列表 -->
                                        <div v-if="editEmploy && !isMypersonalRecords">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="职务" :rules="postRules">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                    <el-input v-model="item.post" v-can-edit v-listpage-dialog :can-edit="editEmploy" listviewurl="rsgl.config.list_zw?urlsearch=status:1" dialog-title="选择职务" :multiple="false" :index="index" placeholder="请选择职务" name="post" exclude-fields="status,blankPlace" retain-btns="" />
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else>{{ item.post }}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_职级" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'postRank'" class="field">职级</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <!-- <form-item ref="postRank" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入职级','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'职级','propName':'postRank','propType':'String','textFormatter':'textfield','valueMaxLength':50,'valueMinLength':null,'model':'item.postRank','option':[],'autocomplete':'off','showWordLimit':false,'dialog':1,'dialogType':'listpage','dialogOrgLevel':'','dialogMultiple':false,'dialogTitle':'选择职级','dialogListviewurl':'rsgl.config.list_zj?urlsearch=status:1'}" :vo="item" :can-edit="canEdit" /> -->

                                        <div v-if="editEmploy && !isMypersonalRecords">
                                            <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="职务" :rules="postRankRules">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                    <el-input v-model="item.postRank" v-can-edit v-listpage-dialog :can-edit="editEmploy" listviewurl="rsgl.config.list_zj?urlsearch=status:1" dialog-title="选择职级" :multiple="false" :index="index" placeholder="请选择职级" name="postRank" exclude-fields="status,blankPlace" retain-btns="" />
                                                </el-tooltip>
                                            </ValidationProvider>
                                        </div>
                                        <div v-else>{{ item.postRank }}</div>
                                    </td>
                                    <td ref="tdlbl_排序编号" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'sortNumber'" class="field">排序编号</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <form-item
                                            ref="sortNumber"
                                            :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入排序编号', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '排序编号', propName: 'sortNumber', propType: 'String', textFormatter: 'textfield', valueMaxLength: 10, valueMinLength: null, model: 'item.sortNumber', option: [], autocomplete: 'off', showWordLimit: false }"
                                            :vo="item"
                                            :can-edit="editEmploy && !isMypersonalRecords"
                                        />
                                    </td>
                                    <td ref="tdlbl_编制部门" class="el-table__cell tdlbl tdw13" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'preparationDepart'" class="field">编制部门</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw20" colspan="1">
                                        <form-item
                                            ref="preparationDepart"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{${canEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '0：是\n1：否',
                                                elementReadonly: 1,
                                                elementType: 'radio',
                                                emptyMessage: '请选择编制部门',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 1,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '编制部门',
                                                propName: 'preparationDepart',
                                                propType: 'Short',
                                                textFormatter: null,
                                                valueMaxLength: 10,
                                                valueMinLength: null,
                                                model: 'item.preparationDepart',
                                                option: [
                                                    { value: '0', name: '是' },
                                                    { value: '1', name: '否' }
                                                ],
                                                optionGenerateType: 0,
                                                clearable: true,
                                                filterable: false,
                                                allowCreate: false
                                            }"
                                            :vo="item"
                                            :can-edit="editEmploy && !isMypersonalRecords"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
        </div>
        <div v-if="editEmploy && !isMypersonalRecords" class="addappointmnetInfo">
            <el-link type="primary" size="small" icon="el-icon-plus" @click="addAppointmnetInfo">添加任职信息</el-link>
        </div>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    name: 'AppointmnetInfos',
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup() {
        const postRules = {
            required: true
        }
        const departmentRules = {
            required: true
        }
        const postRankRules = {
            required: true
        }

        return {
            postRules, // 职务
            departmentRules, // 部门
            postRankRules // 职级
        }
    },
    data: function () {
        return {
            loginUser: this.$store.getters.loginUser,
            selectRow: {},
            editEmploy: 0
        }
    },
    computed: {},
    watch: {},
    created: function () {
        if (this.$parent.$vnode.context.activeTabIndex) {
            this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        }
        console.log(this.vo, 'this.vo')

        if (this.canEdit) {
            let isAdmin = this.$store.state.user.roles.includes('dwAdministrators')
            if (isAdmin) {
                this.editEmploy = 1
            }
        }

        this.$set(this.$vnode.context, 'wfAttach', false)
    },
    beforeDestroy: function () {},
    mounted: function () {},
    methods: {
        timeFormat(val) {
            return val ? moment(new Date(val)).format('YYYY年MM月DD日') : ''
        },

        selectSuborg(row, index, dialogTitle, name) {
            this.selectRow = row
            const el = {
                dialogTitle,
                index,
                multiple: false,
                attrs: { 'dialog-title': '选择部门', 'root-org-code': this.loginUser.orgCode, 'org-level': '2,3,4', name, index },
                value: ''
            }
            const vnode = {
                context: this,
                data: {
                    model: { expression: 'selectDialog' },
                    attrs: {}
                }
            }

            this.$bus.emit('RsglOpenSelectDialog', el, { value: 'suborg' }, vnode)
        },
        convertToChineseNumber(num) {
            const chineseDigits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
            const tens = ['', '十', '二十', '三十', '四十', '五十', '六十', '七十', '八十', '九十']

            if (num === 0) {
                return chineseDigits[0]
            }

            const units = num % 10
            const tensPart = Math.floor(num / 10) * 10

            let result = ''

            if (tensPart > 0) {
                result += tens[tensPart / 10]
            }

            if (units > 0) {
                result += chineseDigits[units]
            }

            // 处理10-19的特殊情况
            if (result.endsWith('十') && units !== 0) {
                result = result.slice(0, -1) + tens[units]
            }

            // 去除开头的零（例如05转换为五而不是零五）
            return result.replace(/^零+/, '')
        },
        // 选择部门
        onSelectSuborgCompleted: function (selectedRows, attr) {
            // debugger
            // if (attr.name === 'department') {
            this.$set(this.vo.passenger.appointmnetInfos[attr.index], 'department', selectedRows[0].name)
            this.$set(this.vo.passenger.appointmnetInfos[attr.index], 'orgFullId', selectedRows[0].orgFullId)
            // }
        },
        // 选择数据列表
        onSelectListpageRowCompleted: function (selectedRows, attr) {
            if (attr.name === 'post') {
                this.$set(this.vo.passenger.appointmnetInfos[attr.index], 'post', selectedRows[0].postName)
            } else if (attr.name === 'postRank') {
                this.$set(this.vo.passenger.appointmnetInfos[attr.index], 'postRank', selectedRows[0].rankName)
            }
        },
        addAppointmnetInfo() {
            // 新增任职信息
            // appointmnetInfo
            this.$http({
                method: 'POST',
                url: '/rsgl/appointmnetInfo/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.appointmnetInfos.push(res.body.vo)
                }
            })
        },
        delAppointmnetInfo(row) {
            this.$confirm('是否确定删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.vo.passenger.appointmnetInfos = this.vo.passenger.appointmnetInfos.filter((item) => item.id !== row.id)
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped>
.rz_title {
    font-size: 14px;
    /* font-weight: 600; */
    margin: 15px 0 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.addappointmnetInfo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
}
.appointmnetInfos .el-table .el-table__body-wrapper .el-table__body .tdlbl {
    background: #F2F5FB !important;
}
</style>
